import { render } from "./Header-Component.vue?vue&type=template&id=2115c736"
import script from "./Header-Component.vue?vue&type=script&lang=js"
export * from "./Header-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__